import script from "./GermanyGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./GermanyGuide.vue?vue&type=script&lang=ts&setup=true"

import "./GermanyGuide.vue?vue&type=style&index=0&id=5083f520&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5083f520"]])

export default __exports__